import { api, ApiRes } from './client'

export const requestPhysicalMail = (membershipDocumentId: string): ApiRes<{ status: boolean }> =>
    api.get(`membership_documents/requestPhysicalMail/${membershipDocumentId}`)
